import { dispatcher, api, RESOURCE_CREATE } from '@unicus/react-ui-kit';

export const ATTENDANCE = 'ATTENDANCE';
export const ATTENDANCE_START_OR_STOP_SERVICE =
  'ATTENDANCE_START_OR_STOP_SERVICE';
export const ATTENDANCE_START_OR_STOP_SERVICE_FINISHED =
  'ATTENDANCE_START_OR_STOP_SERVICE_FINISHED';

export const ATTENDANCE_CREATE_PATIENT = 'ATTENDANCE_CREATE_PATIENT';
export const ATTENDANCE_CREATE_PATIENT_FINISHED =
  'ATTENDANCE_CREATE_PATIENT_FINISHED';

export const ATTENDANCE_SET_EDIT_VALUES = 'ATTENDANCE_SET_EDIT_VALUES';

export const ATTENDANCE_UPDATE_ANSWER = 'ATTENDANCE_UPDATE_ANSWER';
export const ATTENDANCE_UPDATE_ANSWER_FINISHED =
  'ATTENDANCE_UPDATE_ANSWER_FINISHED';

export const ATTENDANCE_UPDATE_DOCUMENT_FIELD =
  'ATTENDANCE_UPDATE_DOCUMENT_FIELD';
export const ATTENDANCE_UPDATE_DOCUMENT_FIELD_FINISHED =
  'ATTENDANCE_UPDATE_DOCUMENT_FIELD_FINISHED';

export const ATTENDANCE_CREATE_DOCUMENT_FIELD =
  'ATTENDANCE_CREATE_DOCUMENT_FIELD';
export const ATTENDANCE_CREATE_DOCUMENT_FIELD_FINISHED =
  'ATTENDANCE_CREATE_DOCUMENT_FIELD_FINISHED';

export const ATTENDANCE_DELETE_DOCUMENT_FIELD =
  'ATTENDANCE_DELETE_DOCUMENT_FIELD';
export const ATTENDANCE_DELETE_DOCUMENT_FIELD_FINISHED =
  'ATTENDANCE_DELETE_DOCUMENT_FIELD_FINISHED';

export const ATTENDANCE_CREATE_DOCUMENT = 'ATTENDANCE_CREATE_DOCUMENT';
export const ATTENDANCE_CLOSE_DOCUMENT = 'ATTENDANCE_CLOSE_DOCUMENT';

export const ATTENDANCE_CREATE_PRESCRIPTION_FIELD =
  'ATTENDANCE_CREATE_PRESCRIPTION_FIELD';
export const ATTENDANCE_CREATE_PRESCRIPTION_FIELD_FINISHED =
  'ATTENDANCE_CREATE_PRESCRIPTION_FIELD_FINISHED';

export const ATTENDANCE_DELETE_PRESCRIPTION_FIELD =
  'ATTENDANCE_DELETE_PRESCRIPTION_FIELD';
export const ATTENDANCE_DELETE_PRESCRIPTION_FIELD_FINISHED =
  'ATTENDANCE_DELETE_PRESCRIPTION_FIELD_FINISHED';

export const ATTENDANCE_UPDATE_PRESCRIPTION_FIELD =
  'ATTENDANCE_UPDATE_PRESCRIPTION_FIELD';
export const ATTENDANCE_UPDATE_PRESCRIPTION_FIELD_FINISHED =
  'ATTENDANCE_UPDATE_PRESCRIPTION_FIELD_FINISHED';

export const ATTENDANCE_CREATE_PRESCRIPTION = 'ATTENDANCE_CREATE_PRESCRIPTION';
export const ATTENDANCE_CLOSE_PRESCRIPTION = 'ATTENDANCE_CLOSE_PRESCRIPTION';

export const ATTENDANCE_PRESCRIPTION_REDIRECT_RECEITA_DIGITAL =
  'ATTENDANCE_PRESCRIPTION_REDIRECT_RECEITA_DIGITAL';
export const ATTENDANCE_PRESCRIPTION_REDIRECT_RECEITA_DIGITAL_FINISHED =
  'ATTENDANCE_PRESCRIPTION_REDIRECT_RECEITA_DIGITAL_FINISHED';

export const ATTENDANCE_PRESCRIPTION_INTEGRATION =
  'ATTENDANCE_PRESCRIPTION_INTEGRATION';
export const ATTENDANCE_PRESCRIPTION_INTEGRATION_FINISHED =
  'ATTENDANCE_PRESCRIPTION_INTEGRATION_FINISHED';

export const ATTENDANCE_GET_ANALYSIS = 'ATTENDANCE_GET_ANALYSIS';
export const ATTENDANCE_GET_ANALYSIS_FINISHED =
  'ATTENDANCE_GET_ANALYSIS_FINISHED';

export const post = (data, onSuccess) => async (dispatch) => {
  await dispatcher.dispatchResouceAction({
    dispatch,
    resource: 'attendances',
    actionType: RESOURCE_CREATE,
    effect: async () => api.post('attendances', data),
    onSuccess
  });
};

export const postStartAndStop = (data, onSuccess) => async (dispatch) => {
  await dispatcher.dispatchResouceAction({
    dispatch,
    resource: 'attendances',
    actionType: RESOURCE_CREATE,
    effect: async () => api.post('attendances/start-and-stop', data),
    onSuccess
  });
};

export const setEditValues = (attendance) => (dispatch) => {
  dispatch(
    dispatcher.createAction(
      ATTENDANCE_SET_EDIT_VALUES,
      'attendances',
      attendance
    )
  );
};

export const stopService = (params, onSuccess) => async (dispatch) => {
  await dispatcher.dispatchResouceAction({
    dispatch,
    resource: 'attendances',
    actionType: ATTENDANCE_START_OR_STOP_SERVICE,
    effect: async () => api.put(`attendances/stop-service`, params),
    onSuccess
  });
};

export const createPatient = (id, params, onSuccess) => async (dispatch) => {
  await dispatcher.dispatchResouceAction({
    dispatch,
    resource: 'patients',
    actionType: RESOURCE_CREATE,
    effect: async () => api.post(`attendances/${id}/patient`, params),
    onSuccess
  });
};

export const updateAnswers = (section, onSuccess) => async (dispatch) => {
  await dispatcher.dispatchResouceAction({
    dispatch,
    resource: 'attendances',
    actionType: ATTENDANCE_UPDATE_ANSWER,
    payload: section,
    effect: async () => api.put(`attendances/save-answer`, section.fields),
    onSuccess
  });
};

export const createDocumentField = (params, onSuccess) => async (dispatch) => {
  await dispatcher.dispatchResouceAction({
    dispatch,
    resource: 'attendances',
    actionType: ATTENDANCE_CREATE_DOCUMENT_FIELD,
    payload: params,
    effect: async () => api.post(`attendances/document-field`, params),
    onSuccess
  });
};

export const createPrescriptionField = (
  params,
  saveAsModel = false,
  onSuccess
) => async (dispatch) => {
  await dispatcher.dispatchResouceAction({
    dispatch,
    resource: 'attendances',
    actionType: ATTENDANCE_CREATE_PRESCRIPTION_FIELD,
    payload: params,
    effect: async () =>
      api.post(
        `attendances/prescription-field/?saveAsModel=${saveAsModel}`,
        params
      ),
    onSuccess
  });
};

export const updateDocumentField = (params, onSuccess) => async (dispatch) => {
  await dispatcher.dispatchResouceAction({
    dispatch,
    resource: 'attendances',
    actionType: ATTENDANCE_UPDATE_DOCUMENT_FIELD,
    payload: params,
    effect: async () => api.put(`attendances/document-field`, params),
    onSuccess
  });
};

export const deleteDocumentField = (id, onSuccess) => async (dispatch) => {
  await dispatcher.dispatchResouceAction({
    dispatch,
    resource: 'attendances',
    actionType: ATTENDANCE_DELETE_DOCUMENT_FIELD,
    payload: id,
    effect: async () => api.del('attendances', `${id}/document-field`),
    onSuccess
  });
};

export const createDocumentEdit = (initialValues) => (dispatch) => {
  dispatch(
    dispatcher.createAction(
      ATTENDANCE_CREATE_DOCUMENT,
      'attendances',
      initialValues
    )
  );
};

export const closeDocumentEdit = () => (dispatch) => {
  dispatch(dispatcher.createAction(ATTENDANCE_CLOSE_DOCUMENT, 'attendances'));
};

export const createPrescriptionEdit = (initialValues) => (dispatch) => {
  dispatch(
    dispatcher.createAction(
      ATTENDANCE_CREATE_PRESCRIPTION,
      'attendances',
      initialValues
    )
  );
};

export const closePrescriptionEdit = () => (dispatch) => {
  dispatch(
    dispatcher.createAction(ATTENDANCE_CLOSE_PRESCRIPTION, 'attendances')
  );
};

export const deletePrescriptionField = (id, onSuccess) => async (dispatch) => {
  await dispatcher.dispatchResouceAction({
    dispatch,
    resource: 'attendances',
    actionType: ATTENDANCE_DELETE_PRESCRIPTION_FIELD,
    payload: id,
    effect: async () => api.del('attendances', `${id}/prescription-field`),
    onSuccess
  });
};

export const updatePrescriptionField = (params, onSuccess) => async (
  dispatch
) => {
  await dispatcher.dispatchResouceAction({
    dispatch,
    resource: 'attendances',
    actionType: ATTENDANCE_UPDATE_PRESCRIPTION_FIELD,
    payload: params,
    effect: async () => api.put(`attendances/prescription-field`, params),
    onSuccess
  });
};

export const syncDigitalPrescription = (
  attendanceId,
  code,
  onSuccess
) => async (dispatch) => {
  await dispatcher.dispatchResouceAction({
    dispatch,
    resource: 'attendances',
    actionType: ATTENDANCE_PRESCRIPTION_INTEGRATION,
    effect: async () =>
      api.post(
        `attendances/sync-digital-prescription?attendanceId=${attendanceId}&code=${code}`
      ),
    onSuccess
  });
};

export const createIntegratedPrescription = (
  attendanceId,
  callbackUrl,
  onSuccess
) => async (dispatch) => {
  await dispatcher.dispatchResouceAction({
    dispatch,
    resource: 'attendances',
    actionType: ATTENDANCE_PRESCRIPTION_REDIRECT_RECEITA_DIGITAL,
    effect: async () =>
      api.get(
        'attendances',
        `url-new-prescription?attendanceid=${attendanceId}&callbackUrl=${callbackUrl}`
      ),
    onSuccess
  });
};

export const fetchAnalysis = (params, onSuccess, onFail) => async (
  dispatch
) => {
  await dispatcher.dispatchResouceAction({
    dispatch,
    resource: 'attendances',
    actionType: ATTENDANCE_GET_ANALYSIS,
    effect: async () => api.fetch('attendances/analysis', params),
    onSuccess,
    onFail
  });
};
